import api from "./api";
import type { ReadingCycle, ReadingCycleHistory } from "../types";

export const readingCycleService = {
  async getHistory(
    entryId: number,
    signal?: AbortSignal
  ): Promise<ReadingCycleHistory> {
    const response = await api.get<ReadingCycleHistory>(`/reading-cycles/${entryId}`, {
      signal,
    });
    return response.data;
  },
  async startReread(
    entryId: number,
    expectedCycleOrdinal?: number
  ): Promise<ReadingCycle> {
    const response = await api.post<ReadingCycle>(`/reading-cycles/${entryId}/reread`, {
      contract_version: "v1",
      expected_cycle_ordinal: expectedCycleOrdinal,
    });
    return response.data;
  },
};
